/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.8.2.0 (NJsonSchema v10.2.1.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export interface InsightsViewModel {
    OverallPercentile: number;
    AvgCorrect: number;
    Categories: InsightCategoryViewModel[];
}

export interface InsightCategoryViewModel {
    Percentile: number;
    AvgCorrect: number;
    OtherUsers: number;
    UniqueQuestions: number;
    Name: string;
    Color: string;
    Id: string;
    Sessions: InsightSessionsViewModel[];
}

export interface InsightSessionsViewModel {
    SessionId: string;
    Date: Date;
    Result: number;
}

export interface LessonsViewModel {
    Lessons: LessonsLessonViewModel[];
    Categories: LessonsCategoryViewModel[];
}

export interface LessonsLessonViewModel {
    Id: string;
    CategoryId: string;
    Modified: Date;
    Name: string;
    HaveAccess: boolean;
    Thumbnail: string;
    Title: string;
    Description: string;
    VideoContent: string;
    Tags: LessonsLesonTagViewModel[];
}

export interface LessonsLesonTagViewModel {
    Id: string;
    Name: string;
}

export interface LessonsCategoryViewModel {
    Id: string;
    Name: string;
}

export interface LessonViewModel {
    Id: string;
    CategoryId: string;
    Modified: Date;
    Name: string;
    HaveAccess: boolean;
    Thumbnail: string;
    Title: string;
    Description: string;
    VideoContent: string;
    Tags: LessonTag[];
}

export interface LessonTag {
    Id: string;
    Name: string;
}

export interface TenantSettingsViewModel {
    GoogleTagManager: string;
    GoogleTagManagerAuth: string;
    AppName: string;
    PolicyUrl: string;
    PrimaryPalette: string;
    SecondaryPalette: string;
    BrowserThemeColor: string;
    ImageRootPath: string;
    Logo: string;
    Auth0Logo: string;
    Auth0ClientId: string;
    Auth0Domain: string;
    PayPalPublicKey: string;
    StripePublicKey: string;
    StripeCurrency: string;
    IsProduction: boolean;
    TenantId: string;
}

export interface ProblemDetails {
    Type: string;
    Title: string;
    Status: number | undefined;
    Detail: string;
    Instance: string;
    Extensions: { [key: string]: any };
}

export interface UserPackageViewModel {
    Categories: UserPackageCategoryViewModel[];
}

export interface UserPackageCategoryViewModel {
    Id: string;
    Name: string;
    Color: string;
    PreferedLanguage: string;
    AlreadyHave: boolean;
    Percentile: number;
    CanPracticeWeaknesses: boolean;
    AvaliableQuestions: number;
}

export interface PackagesViewModel {
    Packages: PackageViewModel[];
}

export interface PackageViewModel {
    PackageId: string;
    Name: string;
    Description: string;
    AlreadyHave: boolean;
    Left: string;
    Subscriptions: SubscriptionViewModel[];
}

export interface SubscriptionViewModel {
    Duration: string;
    Price: string;
    Description: string;
    Currency: string;
}

export interface TransactionViewModel {
    IsCompleted: boolean;
    Created: string;
    TransactionId: string;
    Name: string;
    Description: string;
    Duration: string;
    Amount: number;
    Currency: string;
    Provider: string;
}

export interface StartTestSessionViewModel {
    Id: string;
    Categories: SessionResultCategoryViewModel[];
}

export interface SessionResultCategoryViewModel {
    Id: string;
    Order: number;
    DisplayName: string;
    CategoryColor: string;
    IsSingleCorrect: boolean;
    MaxTotalTimeS: number;
    MaxQuestionTimeS: number;
    CorrectNormalized: number;
    UnansweredNormalized: number;
    TotalTimeSpentS: number;
    Questions: SessionResultQuestionViewModel[];
}

export interface SessionResultQuestionViewModel {
    Id: string;
    Order: number;
    IsSingleCorrect: boolean;
    Title: string;
    Name: string;
    Body: string;
    Image: string;
    MostEffectiveAnswer: string;
    LessEffectiveAnswer: string;
    TimeSpentMs: number;
    Percent: number;
    State: QuestionAnswerState;
    IsAnswered: boolean;
    IsViewed: boolean;
    AvgDuration: number;
    Options: SessionResultOptionViewModel[];
}

export enum QuestionAnswerState {
    Incorrect = 0,
    Correct = 1,
    Partial = 2,
}

export interface SessionResultOptionViewModel {
    Id: string;
    Order: number;
    Text: string;
    Explanation: string;
    ExplanationVideo: string;
    LeastEffectiveState: QuestionAnswerState;
    MostEffectiveState: QuestionAnswerState;
    IsSelectedLess: boolean;
    IsSelectedMost: boolean;
}

export interface StartTestSessionCommand {
    TestSessionType: TestSessionType;
    CategoryIds: string[];
}

export enum TestSessionType {
    NotSet = 0,
    Practice = 1,
    Exam = 2,
    Weaknesses = 3,
}

export interface CloseTestSessionCommand {
    SessionId: string;
    Questions: CloseTestSessionCommandQuestion[];
}

export interface CloseTestSessionCommandQuestion {
    Id: string;
    Duration: number;
    LessEffectiveAnswer: string;
    MostEffectiveAnswer: string;
}

export interface SessionResultViewModel {
    Id: string;
    SessionType: TestSessionType;
    CorrectNormalized: number;
    UnansweredNormalized: number;
    TotalTimeSpentS: number;
    Categories: SessionResultCategoryViewModel[];
}

export interface SendQuestionFeedbackCommand {
    QuestionId: string;
    FeedbackMessage: string;
}

export interface TimelineViewModel {
    Items: TimelineItemViewModel[];
}

export interface TimelineItemViewModel {
    Id: string;
    ActivityContextId: UserActivityContext;
    ActivityContext: string;
    ActivityType: TestSessionType;
    Created: string;
    TotalCorrectNormalized: number;
    TotalTimeSpentMs: number;
    TestSessionCategories: TimelineTestSessionCategoryViewModel[];
}

export enum UserActivityContext {
    None = 0,
    TestSession = 1,
}

export interface TimelineTestSessionCategoryViewModel {
    CategoryName: string;
    CategoryColor: string;
    CorrectNormalized: number;
}

export interface UserSettingsViewModel {
    CategoriesSettings: UserCategorySettingsViewModel[];
}

export interface UserCategorySettingsViewModel {
    CategoryId: string;
    Name: string;
    SelectedLanguage: string;
    QuestionsLimit: number;
    AvailableLanguages: LanguageViewModel[];
    AvailableQuestionsLimit: number[];
}

export interface LanguageViewModel {
    Name: string;
    Code: string;
}

export interface SaveUserSettingsCommand {
    CategoriesSettings: UserCategorySettingsViewModel2[];
}

export interface UserCategorySettingsViewModel2 {
    CategoryId: string;
    SelectedLanguage: string;
    QuestionsLimit: number;
}

export interface VersionViewModel {
    Version: string;
    Environment: string;
    Description: string;
}

export interface PayPalCreateOrderCommand {
    PackageId: string;
    Amount: number;
    Name: string;
    Description: string;
}

export interface PayPalProcessOrderCommand {
    PackageId: string;
    Name: string;
    Description: string;
    Duration: number;
    Amount: number;
    OrderId: string;
}

export interface StripeCreateCheckoutSessionCommand {
    PackageId: string;
    Name: string;
    Description: string;
    Duration: number;
    Amount: number;
    SuccessUrl: string;
    CancelUrl: string;
}
